<template>
    <div class="credits-manager-type-1" :class="[percClass, card ? 'card' : '']" v-if="ppCredits">
        <div class="top" v-if="card">
            <div class="card-title">{{$t('common.credits')}}</div>
        </div>
        <div class="center">
            <div class="progress-bar">
                <div class="progress" :style="{ width: perc + '%' }"></div>
            </div>
        </div>
        <div class="bottom">
            <div class="legend">{{$t(card ? 'common.used' : 'common.credits_used')}}</div>
            <div class="credits">
                <span class="used">{{formatNumber(ppCredits.credits_used_month || ppCredits.monthly_credits)}}</span>
                <span class="slash">/</span>
                <span class="total">{{formatNumber(ppCredits.monthly_credits)}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'pinia';
    import { useApiCreditsStore } from '@/stores/apiCredits';
    import { formatNumber } from '@/utils/formatting';

    export default {
        name: 'PpCreditsManager',
        props: {
            card: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                loaded: false,
            };
        },
        computed: {
            ...mapState(useApiCreditsStore, ['ppCredits']),
            perc() {
                if (this.ppCredits) {
                    const perc = Math.round((this.ppCredits.credits_used_month / this.ppCredits.monthly_credits) * 100);
                    return perc > 100 ? 100 : perc;
                }
                return 100;
            },
            percClass() {
                return this.perc <  50 ? 'success' : this.perc < 80 ? 'warning' : 'error';
            },
            available() {
                if (this.ppCredits) {
                    const count = this.ppCredits.monthly_credits - this.ppCredits.credits_used_month;
                    return count > 0 ? count : 0;
                }
                return 0;
            },
        },
        methods: {
            formatNumber,
            ...mapActions(useApiCreditsStore, ['getApiCredits']),
        },
        async mounted() {
            await this.getApiCredits();
            this.loaded = true;
        },
    };
</script>
